import React from 'react';
import { useFramework } from '@/framework';
import { PluginType, type IExportPlugin } from '@/version-types';
import { useCloneHotkey } from './use-clone-hotkey';
import { useDeleteLayerHotkey } from './use-delete-hotkey';
import { useLockLayerHotkey } from './use-lock-hotkey';
import { useMoveLayerHotkey } from './use-move-hotkey';
import { useSortLayerHotkey } from './use-sort-hotkey';

/**
 * 基础图层相关快捷键：创建副本、删除、锁定、移动、排序（子逻辑见 `use-*-hotkey.ts`）。
 */
const LayerHotkeyView: React.FC = React.memo(() => {
    const framework = useFramework();

    useCloneHotkey(framework);
    useDeleteLayerHotkey(framework);
    useLockLayerHotkey(framework);
    useMoveLayerHotkey(framework);
    useSortLayerHotkey(framework);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'layer-hotkey',
    render() {
        return <LayerHotkeyView />;
    },
};

export default exportPlugin;
